// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_or-0";